import styled from 'styled-components'
import { Box } from 'rebass'
import media from '../../../utils/style'

export const FormWrapper = styled(Box)`
  max-width: ${(props) => props.theme.content.max.width};

  margin: 10px 10px 20px 10px;
  border-radius: 12px;

  background-color: ${(props) => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  padding: 16px;

  ${media.MediumScreenUp`
    margin: 0 auto 30px auto;
  `}

  ${media.LargeScreenUp`
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto 40px auto;
    padding: 10px;
    gap: 24px;
  `}
`

export const FormSelectFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  ${media.LargeScreenUp`
    flex-direction: row;
    gap: 24px;
`}
`

export const Separator = styled.div`
  display: none;
  width: 1px;
  height: 38px;
  background-color: rgba(29, 79, 103, 0.25);
  ${media.LargeScreenUp`
    display: block;
`}
`
